import { render, staticRenderFns } from "./privacyAgreementNew.vue?vue&type=template&id=4956e5b2&scoped=true&"
import script from "./privacyAgreementNew.vue?vue&type=script&lang=js&"
export * from "./privacyAgreementNew.vue?vue&type=script&lang=js&"
import style0 from "./privacyAgreementNew.vue?vue&type=style&index=0&id=4956e5b2&scoped=true&lang=css&"
import style1 from "./privacyAgreementNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956e5b2",
  null
  
)

export default component.exports